import React, {Component} from 'react'
import {Link} from 'gatsby'
import styled from "styled-components";
import {media} from "utils/Media"

const date = new Date();

const FooterWrapper = styled.footer`
  border-top: 1px dotted black;
  background: white;
  color: black;
  display: flex;
  justify-content: space-between;
  padding: 2rem 1rem;

  ul {
    list-style: none;

  }

  li, li a {
    color: black;
    display: inline-block;
    padding: 0 1rem;
  }
`

class CleanFooter extends Component {
    render() {

        return (
            <FooterWrapper>
                <ul>
                        <li><Link to={"/privacy-policy/"}>Privacy Policy</Link></li>
                        <li><Link to={"/cookie-policy/"}>Cookie Policy</Link></li>
                </ul>
                <ul>
                    <li>The Book Of Mormon copyright {date.getFullYear()}</li>
                </ul>
            </FooterWrapper>
        );
    }
};

export default CleanFooter